import React, { useEffect, useState } from 'react';
import { TableLayout } from '../../containers/Layout';
import { TableRow, TableCell, TableHead, TableBody } from '@material-ui/core';
import { fetchTransferDetails } from '../../../../../../../../jsx/actions/transferAction';
import SingleTransferTemplate from '../singleTemplates/SingleTransferTemplate';
import { useDispatch } from 'react-redux';

const SingleTransferInstall = (props) => {
    const dispatch = useDispatch();
    const [install, setInstall] = useState({});

    useEffect(() => {
        const fetchTransferData = async () => {
            try {
                const installData = await dispatch(fetchTransferDetails(props.install.id));
                setInstall(installData);
            } catch (error) {
                console.error('Error fetching install details:', error);
            }
        };
        
        fetchTransferData();
    }, [dispatch, props.install.id]);

    const createProductList = () => {
        const { PRODUCTS } = props;

        return install.products && install.products.map((item) => {
            let prod = PRODUCTS && PRODUCTS[item.product_id];

            return (
                <TableRow key={item.id}>
                    <TableCell className="text-left">{prod?.name || `Product ID: ${item.product_id}`}</TableCell>
                    <TableCell>{item.quantity}</TableCell>
                </TableRow>
            );
        });
    };
    const handleInstallToSale = () => {
        console.log('================ INSTALL TO SALE ====================');
        console.log("IN handleInstallToSale");
        console.log('====================================');
        props.handleInstallToSale(install, props.client)
    }
    const { shop, client, notif } = props;

    return (
        <SingleTransferTemplate  
            shop={shop} 
            client={client} 
            transfer={install} 
            notif={notif}
            handleInstallToSale={!install.received && handleInstallToSale}
        >
            <div>
                <TableLayout>
                    <TableHead>
                        <TableRow>
                        <TableCell className="text-left">Produit</TableCell>
                        <TableCell>Quantité</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {createProductList()}
                        <TableRow>
                        <TableCell colSpan={2}></TableCell>
                        </TableRow>
                    </TableBody>
                </TableLayout>
            </div>
        </SingleTransferTemplate>
    );
};

export default SingleTransferInstall;
